import React, { useState, useCallback, useEffect, useRef } from 'react';

// icons
import CloseIcon from '@mui/icons-material/Close';

export function DependentsAddForm(
  { isOpen,
    onClose,
    employeeId,
    addEmployeesDependets }) {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [extensionName, setExtensionName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [civilStatus, setCivilStatus] = useState('');

  const handleSubmit = () => {
    if (!lastName
      || !firstName
      || !middleName
      || !dateOfBirth
      || !gender
      || !civilStatus
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesDependets(employeeId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus);
    // Clear form fields
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  };

  const handleClose = () => {
    onClose();
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="dependents-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Add Dependents</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Last Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Dependents-LastName" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">First Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Dependents-FirstName" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Middle Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Dependents-MiddleName" placeholder="Middle Name" onChange={(e) => setMiddleName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Extension Name</div>
                  <div className="info-item-input"><input id="AddEmployee-Dependents-ExtensionName" placeholder="Extension Name" onChange={(e) => setExtensionName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date of Birth</div>
                  <div className="info-item-input"><DateInput2 id="Dependents-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Gender</div>
                  <div className="info-item-input"><Gender2 id="Dependents-Gender" value={gender} onChange={(value) => setGender(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Civil Status</div>
                  <div className="info-item-input"><CivilStatus2 id="Dependents-CivilStatus" value={civilStatus} onChange={(value) => setCivilStatus(value)} /></div>
                </div>
                <div className="dependents-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-dependents"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export function DependentsEditForm(
  { isOpen,
    onClose,
    editData,
    employeeId,
    addEmployeesDependets }) {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [extensionName, setExtensionName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [civilStatus, setCivilStatus] = useState('');

  const handleSubmit = () => {
    if (!lastName
      || !firstName
      || !middleName
      || !dateOfBirth
      || !gender
      || !civilStatus
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesDependets(employeeId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus);
    // Clear form fields
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  };
  const handleClose = () => {
    onClose();
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  }

  useEffect(() => {
    if (isOpen) {
      setLastName(editData.lastName);
      setFirstName(editData.firstName);
      setMiddleName(editData.middleName);
      setExtensionName(editData.extensionName);
      setDateOfBirth(editData.dateOfBirth);
      setGender(editData.gender);
      setCivilStatus(editData.civilStatus);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="dependents-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Edit Dependents</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Last Name</div>
                  <div className="info-item-input"><input value={lastName} id="AddEmployee-Dependents-LastName" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">First Name</div>
                  <div className="info-item-input"><input value={firstName} id="AddEmployee-Dependents-FirstName" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Middle Name</div>
                  <div className="info-item-input"><input value={middleName} id="AddEmployee-Dependents-MiddleName" placeholder="Middle Name" onChange={(e) => setMiddleName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Extension Name</div>
                  <div className="info-item-input"><input value={extensionName} id="AddEmployee-Dependents-ExtensionName" placeholder="Extension Name" onChange={(e) => setExtensionName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date of Birth</div>
                  <div className="info-item-input"><DateInput2 id="Dependents-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Gender</div>
                  <div className="info-item-input"><Gender2 id="Dependents-Gender" value={gender} onChange={(value) => setGender(value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Civil Status</div>
                  <div className="info-item-input"><CivilStatus2 id="Dependents-CivilStatus" value={civilStatus} onChange={(value) => setCivilStatus(value)} /></div>
                </div>
                <div className="dependents-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-dependents"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

function Gender2({ id, value, onChange }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    onChange(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (value !== "" && value !== 0 && value !== null && value !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [value]);

  return (
    <div>
      <select id={"AddEmployee-" + id} value={value || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </select>
    </div>
  );
}

function CivilStatus2({ id, value, onChange }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    onChange(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (value !== "" && value !== 0 && value !== null && value !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [value]);

  return (
    <div>
      <select id={"AddEmployee-" + id} value={value || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        <option value="Single">Single</option>
        <option value="Maried">Maried</option>
      </select>
    </div>
  );
}

function DateInput2({ id, value, onChange }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    onChange(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (value !== undefined && value !== "" && value !== null) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [value]);

  let formattedDate = "";

  if (value) {
    formattedDate = value.split('T')[0];
  }

  return (
    <div>
      <input
        type="date"
        id={"AddEmployee-" + id}
        name="datetime"
        value={formattedDate || ''}
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
        }}
      />
    </div>
  );
}